import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { StepProps } from "./step";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ, MQ_DISPLAY } from "../../../styles/breakpoints";
import { Content, LinkableContent } from "./content";
import React from "react";
import { wrapperStyles, xxxStyles } from "./spare-parts-navigation";

export const SparePartsMobileNavigation: ReactTFC<{
  previousStep: StepProps;
  currentStep: StepProps;
  nextStep: StepProps;
}> = ({ previousStep, currentStep, nextStep }) => {
  const navSteps = css`
    position: absolute;
    top: 50%;

    &:before {
      content: "";

      top: 50%;
      transform: translateY(-50%);

      position: absolute;
      height: 1px;
      width: calc(var(--gap) - var(--x));
      background-color: ${CSS_COLORS.Grey2};
    }
  `;

  return (
    <div
      css={[
        MQ_DISPLAY.onlyAtMostSm,
        css`
          margin-bottom: 70px;

          display: flex;
          justify-content: center;

          --size: 42px;
          --font-size: 24px;
          ${CSS_MQ.atLeastSm} {
            --size: 50px;
            --font-size: 30px;
          }

          --gap: 30vw;
          --x: 8vw;
        `,
      ]}
    >
      <div
        css={[
          wrapperStyles,
          css`
            position: relative;
          `,
        ]}
      >
        {currentStep.step && (
          <div className={currentStep.className}>
            <Content text={currentStep.text} label={currentStep.step.label} />
          </div>
        )}

        {previousStep.step && (
          <div
            className={previousStep.className}
            css={[
              xxxStyles,
              navSteps,
              css`
                transform: translate(calc(var(--size) / 2), -50%) scale(0.7);

                right: calc(100% + var(--gap));

                &:before {
                  left: calc(100% + var(--x));
                }
              `,
            ]}
          >
            <LinkableContent
              link={previousStep.step.link}
              isCurrentlySelected={previousStep.isCurrentlySelected}
              label={previousStep.step.label}
              text={previousStep.text}
            />
          </div>
        )}

        {nextStep.step && (
          <div
            className={nextStep.className}
            css={[
              xxxStyles,
              navSteps,
              css`
                transform: translate(calc(-1 * var(--size) / 2), -50%) scale(0.7);

                left: calc(100% + var(--gap));

                &:before {
                  right: calc(100% + var(--x));
                }
              `,
            ]}
          >
            <LinkableContent
              link={nextStep.step.link}
              isCurrentlySelected={nextStep.isCurrentlySelected}
              label={nextStep.step.label}
              text={nextStep.text}
            />
          </div>
        )}
      </div>
    </div>
  );
};
